import configureMeasurements from 'convert-units';

import { reduxStore } from 'services/configureStore';

//Conditional import needed so that tests don't break due to problem with library
let allMeasures;

if (process.env.NODE_ENV !== 'test') {
	allMeasures = require('convert-units/definitions/all').default;
} else {
	allMeasures = {};
}

// Configure unit conversion
const convertMeasurements = configureMeasurements(allMeasures);
const allUnits = convertMeasurements().list();

const metricUnits = new Set(
	allUnits.filter(unit => unit.system === 'metric').map(unit => unit.abbr)
);
const imperialUnits = new Set(
	allUnits.filter(unit => unit.system === 'imperial').map(unit => unit.abbr)
);
export const getUnits = () => reduxStore.getState().global.units; // Directly fetch from Redux

export const convert = (value, fromUnit, toUnit, options = {}) => {
	if (value === null || value === undefined) {
		return null;
	}
	const { addLabel = false, decimals = 2, ignoreUserSelectedUnitsSystem = false } = options;

	const userUnitSystem = getUnits();

	const isMetric = userUnitSystem === 'metric';
	const isInputMetric = metricUnits.has(fromUnit);
	const isInputImperial = imperialUnits.has(fromUnit);

	// Helper function to round values
	const roundValue = (val, unit) => {
		if (['C', 'F'].includes(unit)) {
			return Math.round(val);
		}
		const factor = Math.pow(10, decimals);
		return Math.round(val * factor) / factor;
	};

	// Helper function to format output
	const formatOutput = (val, unit) => {
		if (!addLabel) return val;
		switch (unit) {
			case 'knot':
				return `${val} kts`;
			case 'C':
				return `${val}°C`;
			case 'F':
				return `${val}°F`;
			default:
				return `${val} ${unit}`;
		}
	};

	const useUserSelectedUnitsSystem = !ignoreUserSelectedUnitsSystem;

	if (useUserSelectedUnitsSystem) {
		//Default behavior is for convert to skip conversion if the units are of the same system
		//This is because most measurements displayed in the UI have only two unit options - one for metric and one for imperial
		//This detects what the input unit is and whether or not it needs to be convered based on the user's chosen unit system

		//For areas of the app where you always want to convert between the two units (rather than automatic detection of the user's chosen unit system), set ignoreUserSelectedUnit to true
		if ((isMetric && isInputMetric) || (!isMetric && isInputImperial)) {
			return formatOutput(roundValue(value, fromUnit), fromUnit);
		}
	}

	try {
		const convertedValue = convertMeasurements(value).from(fromUnit).to(toUnit);
		return formatOutput(roundValue(convertedValue, toUnit), toUnit);
	} catch (error) {
		console.error(`Conversion error: ${error}`);
		return formatOutput(roundValue(value, fromUnit), fromUnit);
	}
};
